const washAndIronHouse = [
	{
		id: '1301',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet',
		category: 'Household',
		service: 'Wash And Iron',
		price: 80,
		quantity: 1
	},
	{
		id: '1302',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Pillow Case',
		category: 'Household',
		service: 'Wash And Iron',
		price: 40,
		quantity: 1
	},
	{
		id: '1303',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Towel',
		category: 'Household',
		service: 'Wash And Iron',
		price: 50,
		quantity: 1
	},
	{
		id: '1304',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket',
		category: 'Household',
		service: 'Wash And Iron',
		price: 250,
		quantity: 1
	},
	{
		id: '1305',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Blanket',
		category: 'Household',
		service: 'Wash And Iron',
		price: 15,
		quantity: 1
	},
	{
		id: '1306',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Accessories (Prayer Cap / Napkin etc)',
		category: 'Household',
		service: 'Wash And Iron',
		price: 45,
		quantity: 1
	},
	{
		id: '1307',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Travel Bag',
		category: 'Household',
		service: 'Wash And Iron',
		price: 200,
		quantity: 1
	}
];
export default washAndIronHouse;
